module.exports = __webpack_public_path__ + "static/media/swiss_knife.e951a462.png";